import React from 'react';
import { FaChartLine, FaHandHoldingUsd, FaSeedling, FaUsers, FaQuoteLeft, FaArrowRight } from 'react-icons/fa';
import Footer from './Footer';
import './fitforlife.css';
import leaderImg from '../Assets/bAguma.jpeg';
import aboutImg from '../Assets/training.jpg';

const APPLY_URL = 'https://thecitychurchluzira.churchcenter.com/people/forms/938149';

const FEATURES = [
  { icon: <FaChartLine aria-hidden="true" />, title: 'Business Planning', desc: 'Turn your idea into a clear, workable plan you can act on.' },
  { icon: <FaHandHoldingUsd aria-hidden="true" />, title: 'Financial Management', desc: 'Budgeting, saving and managing money with wisdom and discipline.' },
  { icon: <FaSeedling aria-hidden="true" />, title: 'Entrepreneurship & Mentorship', desc: 'Practical coaching from people who have built and grown real businesses.' },
  { icon: <FaUsers aria-hidden="true" />, title: 'Community & Networking', desc: 'Grow alongside a community of builders, doers and encouragers.' },
];

const TESTIMONIALS = [
  { quote: 'Fit for Life changed my perspective on business. I now have a clear plan for my startup!', name: 'Matege Billbright' },
  { quote: 'The financial management sessions were eye-opening. I feel far more confident managing my finances.', name: 'Julius Oboth' },
];

const FitForLife = () => (
  <>
    <header className="ffl-hero">
      <div className="tcc-container ffl-hero__inner">
        <p className="tcc-eyebrow ffl-hero__eyebrow">Business &amp; life skills</p>
        <h1 className="ffl-hero__title">Fit for Life</h1>
        <p className="ffl-hero__lead">
          An initiative by The City Church to equip our members with the business
          and life skills to build, grow and thrive, all rooted in faith.
        </p>
        <div className="ffl-hero__actions">
          <a className="tcc-btn tcc-btn--accent tcc-btn--lg" href={APPLY_URL} target="_blank" rel="noopener noreferrer">
            Join Now <FaArrowRight aria-hidden="true" />
          </a>
          <a className="tcc-btn tcc-btn--outline-on-dark tcc-btn--lg" href="#ffl-director">Meet the Director</a>
        </div>
      </div>
    </header>

    {/* About */}
    <section className="tcc-section ffl-about" aria-labelledby="ffl-about-h">
      <div className="tcc-container ffl-about__grid">
        <div className="ffl-about__media">
          <img src={aboutImg} alt="Members at a Fit for Life training session" loading="lazy" />
        </div>
        <div className="ffl-about__text">
          <p className="tcc-eyebrow">About the program</p>
          <h2 className="tcc-h2" id="ffl-about-h">Skills for business and life</h2>
          <p>
            Fit for Life is a transformative initiative designed to equip church
            members with the skills and knowledge to succeed in business and
            personal development.
          </p>
          <p>
            From business planning to financial management, the program offers
            practical tools and mentorship to help you thrive, and a community that
            grows with you.
          </p>
        </div>
      </div>
    </section>

    {/* What you'll gain */}
    <section className="tcc-section tcc-section--surface2 ffl-features" aria-labelledby="ffl-feat-h">
      <div className="tcc-container">
        <div className="ffl-head">
          <p className="tcc-eyebrow">What you&rsquo;ll gain</p>
          <h2 className="tcc-h2" id="ffl-feat-h">Practical tools you can use</h2>
          <p className="tcc-lead">Every session is hands-on and built around your real goals.</p>
        </div>
        <ul className="ffl-features__grid">
          {FEATURES.map((f) => (
            <li className="ffl-feature tcc-card tcc-card--hover" key={f.title}>
              <span className="ffl-feature__icon">{f.icon}</span>
              <h3 className="ffl-feature__title">{f.title}</h3>
              <p className="ffl-feature__desc">{f.desc}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* Testimonials */}
    <section className="tcc-section ffl-testimonials" aria-labelledby="ffl-test-h">
      <div className="tcc-container">
        <div className="ffl-head">
          <p className="tcc-eyebrow">Stories</p>
          <h2 className="tcc-h2" id="ffl-test-h">From our members</h2>
        </div>
        <ul className="ffl-quotes">
          {TESTIMONIALS.map((t) => (
            <li className="ffl-quote tcc-card" key={t.name}>
              <FaQuoteLeft aria-hidden="true" className="ffl-quote__mark" />
              <p className="ffl-quote__text">{t.quote}</p>
              <p className="ffl-quote__name">{t.name}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* Director */}
    <section id="ffl-director" className="tcc-section tcc-section--surface2 ffl-director" aria-labelledby="ffl-dir-h" style={{ scrollMarginTop: '80px' }}>
      <div className="tcc-container ffl-director__grid">
        <img src={leaderImg} alt="Mrs Rebecca Baguma" className="ffl-director__img" loading="lazy" />
        <div className="ffl-director__text">
          <p className="tcc-eyebrow">Our director</p>
          <h2 className="tcc-h2" id="ffl-dir-h">Mrs Rebecca Baguma</h2>
          <p className="ffl-director__role">Lead, Fit for Life Program</p>
          <p className="ffl-director__bio">
            Mrs Rebecca Baguma is a dedicated advocate for holistic personal
            development and financial empowerment. As lead of the Fit for Life
            program, she guides members through practical workshops on business
            planning, budgeting and entrepreneurship.
          </p>
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="ffl-cta" aria-labelledby="ffl-cta-h">
      <div className="tcc-container ffl-cta__inner">
        <h2 className="ffl-cta__title" id="ffl-cta-h">Ready to build something?</h2>
        <p className="ffl-cta__text">Take the next step in your business and personal growth. Join the next Fit for Life intake.</p>
        <a className="tcc-btn tcc-btn--on-dark tcc-btn--lg" href={APPLY_URL} target="_blank" rel="noopener noreferrer">
          Join Fit for Life <FaArrowRight aria-hidden="true" />
        </a>
      </div>
    </section>

    <Footer />
  </>
);

export default FitForLife;
